// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"resizable-table__visuallyhidden--vMt50","focusable":"resizable-table__focusable--gBQXM","table":"resizable-table__table--BSTLW"};